import { Session } from 'src/state';
import type { UploaderEndpoints } from './ChunkUploader';
import type { SWEvents, UploadFileEvent } from './types';

import UploadWorker from './worker?worker';

export const uploadWorker = async <D>(
  file: File,
  {
    extraStartPayload,
    onProgress,
    endpoints,
  }: {
    extraStartPayload?: Record<string, any>;
    onProgress: (data: { progress: number; speed: number }) => void;
    endpoints: UploaderEndpoints;
  },
): Promise<D> => {
  const worker = new UploadWorker();

  return new Promise<D>((resolve, reject) => {
    worker.onmessage = (event: MessageEvent<SWEvents>) => {
      if (event.data.type === 'progress') {
        onProgress({
          progress: event.data.progress,
          speed: event.data.speed,
        });
      }
      if (event.data.type === 'complete') {
        resolve(event.data.data as D);
        worker.terminate();
      }
      if (event.data.type === 'error') {
        console.error('error', event.data.error);
        reject(event.data.error);
      }
    };

    worker.postMessage({
      type: 'start',
      file,
      endpoints,
      token: Session.getToken() as string,
      extraStartPayload,
    } satisfies UploadFileEvent);
  });
};
